import { TranslatedText } from '../Translation';

export interface GenericSettingsValue {
  stringValue?: string;
  translatedTextValue?: TranslatedText;
  stringArrayValue?: string[];
  intValue?: number;
  decimalValue?: number;
}

export const genericValueFromResponse = (
  responseData: any,
): GenericSettingsValue => ({
  stringValue: responseData.string_value,
  translatedTextValue: responseData.translated_text_value,
  stringArrayValue: responseData.string_array_value,
  intValue: responseData.int_value,
  decimalValue: responseData.decimal_value,
});

export const genericValueToUpsertRequest = (
  genericValue: GenericSettingsValue,
) => ({
  string_value: genericValue.stringValue,
  translated_text_value: genericValue.translatedTextValue,
  string_array_value: genericValue.stringArrayValue,
  int_value: genericValue.intValue,
  decimal_value: genericValue.decimalValue,
});
